import { FC } from 'react';

const KetoFriendlyIcon: FC<{
  fill?: string;
  height?: number;
  width?: number;
}> = ({ fill = '#3C3F43', height = 16, width = 16 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.3401 8.50699C13.6134 3.83366 10.8334 0.166992 8.00007 0.166992C5.16674 0.166992 2.38674 3.83366 1.66007 8.50699C1.50084 9.39272 1.54087 10.3028 1.77727 11.1711C2.01366 12.0394 2.44049 12.8442 3.02674 13.527C3.64702 14.2394 4.41054 14.8131 5.26749 15.2105C6.12443 15.608 7.05554 15.8203 8.00007 15.8337C8.9446 15.8203 9.87571 15.608 10.7327 15.2105C11.5896 14.8131 12.3531 14.2394 12.9734 13.527C13.5597 12.8442 13.9865 12.0394 14.2229 11.1711C14.4593 10.3028 14.4993 9.39272 14.3401 8.50699ZM4.54007 9.52033C4.54007 8.836 4.743 8.16705 5.12319 7.59805C5.50338 7.02906 6.04375 6.58558 6.67599 6.3237C7.30822 6.06182 8.00391 5.9933 8.67508 6.12681C9.34626 6.26031 9.96277 6.58985 10.4467 7.07374C10.9306 7.55763 11.2601 8.17414 11.3936 8.84531C11.5271 9.51649 11.4586 10.2122 11.1967 10.8444C10.9348 11.4766 10.4913 12.017 9.92234 12.3972C9.35335 12.7774 8.68439 12.9803 8.00007 12.9803C7.08242 12.9803 6.20236 12.6158 5.55348 11.9669C4.90461 11.318 4.54007 10.438 4.54007 9.52033Z"
        fill={fill}
      />
      <path
        d="M8.35986 8.11328C8.56496 8.11328 8.76166 8.19476 8.90669 8.33979C9.05172 8.48481 9.1332 8.68151 9.1332 8.88661C9.1332 9.01922 9.18588 9.1464 9.27964 9.24017C9.37341 9.33394 9.50059 9.38661 9.6332 9.38661C9.7658 9.38661 9.89298 9.33394 9.98675 9.24017C10.0805 9.1464 10.1332 9.01922 10.1332 8.88661C10.1332 8.4163 9.94636 7.96524 9.6138 7.63268C9.28124 7.30011 8.83018 7.11328 8.35986 7.11328C8.22725 7.11328 8.10008 7.16596 8.00631 7.25973C7.91254 7.3535 7.85986 7.48067 7.85986 7.61328C7.85986 7.74589 7.91254 7.87307 8.00631 7.96683C8.10008 8.0606 8.22725 8.11328 8.35986 8.11328Z"
        fill={fill}
      />
    </svg>
  );
};

export default KetoFriendlyIcon;
